import { render, staticRenderFns } from "./sonet-single-video.vue?vue&type=template&id=a0bb3b82&scoped=true"
import script from "./sonet-single-video.vue?vue&type=script&lang=js"
export * from "./sonet-single-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bb3b82",
  null
  
)

export default component.exports